import { useEffect, useState } from 'react';
import { compensationApi } from '../../../api/compensation.js';

const money = (v, c = 'IDR') => (v == null ? '—' : `${c} ${Number(v).toLocaleString('en-US')}`);

export default function Awards() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    compensationApi
      .listAwards()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function act(id, fn) {
    setError(null);
    try {
      await fn(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Action failed');
    }
  }

  return (
    <section data-testid="comp-awards-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Compensation Awards</h1>
          <p className="muted">{items.length} awards</p>
        </div>
      </header>

      {error && <div className="alert error" data-testid="comp-awards-error">{error}</div>}

      <div className="card">
        <table className="data-table" data-testid="comp-award-list">
          <thead>
            <tr><th>Employee</th><th>Type</th><th>Amount</th><th>Effective</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} data-testid={`comp-award-row-${a.id}`}>
                <td>{a.employee_name || a.employee_code || a.employee_id}</td>
                <td>{a.type}</td>
                <td>{money(a.amount, a.currency)}</td>
                <td>{a.effective_date ? String(a.effective_date).slice(0, 10) : '—'}</td>
                <td><span className={`chip status-${a.status}`} data-testid={`comp-award-status-${a.id}`}>{a.status}</span></td>
                <td className="actions">
                  {a.status === 'draft' && (
                    <button className="btn" data-testid={`comp-award-submit-${a.id}`} onClick={() => act(a.id, compensationApi.submitAward)}>Submit</button>
                  )}
                  {(a.status === 'pending' || a.status === 'draft') && (
                    <button className="btn primary" data-testid={`comp-award-approve-${a.id}`} onClick={() => act(a.id, compensationApi.approveAward)}>Approve</button>
                  )}
                  {(a.status === 'pending' || a.status === 'draft') && (
                    <button className="btn" data-testid={`comp-award-reject-${a.id}`} onClick={() => act(a.id, compensationApi.rejectAward)}>Reject</button>
                  )}
                </td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={6} className="muted">No awards yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
